
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'DatePicker',
  props: {
    type: String,
    prop: String,
    disabled: Boolean,
    dateTime: Date,
  },
  setup(props, context) {
    const date = ref(props.dateTime);
    const changeTime = () => {
      context.emit('update:dateTime', date.value);
      context.emit('changeTime', date.value);
    };
    return {
      changeTime,
      date,
    };
  },
});
